/**
 * 左侧目录的举腿信息
 */

import { FC, useContext } from 'react'

import { CourseOutlineTaskTypeEnum } from 'packages/sdks-next/growp'

import { CourseContext } from '../../context'

import { PdfContent } from './PdfContent'
import { VideoContent } from './VideoContent'
import { PaperContent } from './PaperContent'

/**
 * 左侧内容
 *
 * @returns 左侧内容
 */
export const LeftContent: FC = () => {
  const { currentOutline, completedDetails, taskId } = useContext(CourseContext)
  const type = currentOutline?.type
  const curCompletedDetail = currentOutline?.key
    ? completedDetails?.find(
        (detail) => detail.outlineTaskId === Number(currentOutline?.key)
      )
    : undefined
  if (!currentOutline || !type) return null
  switch (type) {
    case CourseOutlineTaskTypeEnum.Video:
      return (
        <VideoContent
          url={currentOutline?.attachments?.[0]?.url || ''}
          curCompletedDetail={curCompletedDetail}
        />
      )
    case CourseOutlineTaskTypeEnum.Pdf:
      return (
        <PdfContent
          url={currentOutline?.attachments?.[0]?.url || ''}
          curCompletedDetail={curCompletedDetail}
        />
      )
    case CourseOutlineTaskTypeEnum.Exercise:
      return (
        <PaperContent
          taskId={taskId}
          paperId={currentOutline.paperId || 0}
        />
      )
    default:
      return null
  }
}
